import React, { useState, useEffect } from 'react'
import { Box, Hidden } from '@material-ui/core'
import ArticleAPI from 'api/ArticleAPI'
import ArticlesList from 'components/ArticlesList/ArticlesList'
import MiniArticleList from 'containers/RecentArticles/MiniArticleList'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import { useStyles } from '../../SchoolIndex_style'

import isEmpty from 'lodash.isempty'

const SchoolIndexHalfPageArticles = () => {
    const [articles, setArticles] = useState([])
    const classes = useStyles()

    useEffect(() => {
        getSchoolIndexHalfPageArticles()
    }, [])

    const getSchoolIndexHalfPageArticles = () => {
        const data = { number_of_articles: 4 }

        ArticleAPI.GetSchoolIndexHalfPageArticles(data)
            .then((response) => {
                setArticles(response.data)
            })
    }

    if (isEmpty(articles)) return null

    return (<>
        <Hidden mdUp>
            <Box className={classes.recentNewsTitle}>
                <SectionSubTitle titleId='landing_recent_articles.news_education'/>
            </Box>
            <ArticlesList
                articles={articles}
                category='education'
            />
        </Hidden>
        <Hidden smDown>
            <MiniArticleList
                articles={articles}
                category='education'
            />
        </Hidden>
    </>)
}

export default SchoolIndexHalfPageArticles
